(function(){

  'use strict';

    //*****************//
    // Data that this directive needs
    // -----------------
    // 
    //*****************//

    // 
    // }

  function pxSpinner($timeout, $filter, $window) {
    return {
      restrict: 'EA',
      scope: {
        // checkboxData: '=checkboxData',
        // value: '=value',
        // required: '=required',
        // callback: '&callback'
        reSize: '=reSize'
      },
      templateUrl: 'app/directives/spinnerDirective/spinner.template.html',
      link: function(scope) {


        var config = {
          setup : {
              containerId : 'some-container-id',
              canvasId : 'some-id'
          },
          options : {
              color : '#4b4b4b',
              speed : 0.12,
              radius : 50 / scope.reSize,
              direction : 'right',
              opacity : 1
          },
          advancedOptions : {
              startAngleMinutes : 0,
              startAngleHours : 0,
              armWidthMinute : 2 / scope.reSize,
              armWidthHour : 4 / scope.reSize,
              clockLineWidth : 3 / scope.reSize,
              armColorMinute : null,
              armColorHour : null,
              clockColorLine : null,
              clockColorFill : 'white',
              hoursIndicator : false,
              indicatorColorFill : null
          }
          
      };

      var particle = {
        x: 0,
        y: 0,
        vx: 0,
        vy: 0,
        mass: 1,
        radius: 0,
        bounce: -1,
        friction: 1,
        gravity: 0,
        springs: null,
        gravitation: null,
      
        create: function(x, y, speed, direction, grav) {
          var obj = Object.create(this);
          obj.x = x;
          obj.y = y;
          obj.vx = Math.cos(direction) * speed;
          obj.vy = Math.sin(direction) * speed;
          obj.gravity = grav || 0;
          obj.springs = [];
          obj.gravitation = [];
          return obj;
        },
      
        addGravitation: function(p) {
          this.removeGravitation(p);
          this.gravitation.push(p);
        },
      
        removeGravitation: function(p) {
          for(var i = 0; i < this.gravitation.length; i += 1) {
            if(p === this.gravitation[i]) {
              this.gravitation.splice(i, 1);
              return;
            }
          }
        },
      
        addSpring: function(point, k, length) {
          this.removeSpring(point);
          this.springs.push({
            point: point,
            k: k,
            length: length || 0
          });
        },
      
        removeSpring: function(point) {
          for(var i = 0; i < this.springs.length; i += 1) {
            if(point === this.springs[i].point) {
              this.springs.splice(i, 1);
              return;
            }
          }
        },
      
        getSpeed: function() {
          return Math.sqrt(this.vx * this.vx + this.vy * this.vy);
        },
      
        setSpeed: function(speed) {
          var heading = this.getHeading();
          this.vx = Math.cos(heading) * speed;
          this.vy = Math.sin(heading) * speed;
        },
      
        getHeading: function() {
          return Math.atan2(this.vy, this.vx);
        },
      
        setHeading: function(heading) {
          var speed = this.getSpeed();
          this.vx = Math.cos(heading) * speed;
          this.vy = Math.sin(heading) * speed;
        },
      
        accelerate: function(ax, ay) {
          this.vx += ax;
          this.vy += ay;
        },
      
        update: function() {
          this.handleSprings();
          this.handlegravitation();
          this.vx *= this.friction;
          this.vy *= this.friction;
          this.vy += this.gravity;
          this.x += this.vx;
          this.y += this.vy;
        },
      
        handlegravitation: function() {
          for(var i = 0; i < this.gravitation.length; i += 1) {
            this.gravitateTo(this.gravitation[i]);
          }
        },
      
        handleSprings: function() {
          for(var i = 0; i < this.springs.length; i += 1) {
            var spring = this.springs[i];
            this.springTo(spring.point, spring.k, spring.length);
          }
        }, 
      
        angleTo: function(p2) {
          return Math.atan2(p2.y - this.y, p2.x - this.x);
        },
      
        distanceTo: function(p2) {
          var dx = p2.x - this.x,
            dy = p2.y - this.y;
      
          return Math.sqrt(dx * dx + dy * dy);
        },
      
        gravitateTo: function(p2) {
          var dx = p2.x - this.x,
            dy = p2.y - this.y,
            distSQ = dx * dx + dy * dy,
            dist = Math.sqrt(distSQ),
            force = p2.mass / distSQ,
            ax = dx / dist * force,
            ay = dy / dist * force;
      
          this.vx += ax;
          this.vy += ay;
        },
      
        springTo: function(point, k, length) {
          var dx = point.x - this.x,
            dy = point.y - this.y,
            distance = Math.sqrt(dx * dx + dy * dy),
            springForce = (distance - length || 0) * k; 
          this.vx += dx / distance * springForce,
          this.vy += dy / distance * springForce;
        }
      };
     

        var spinners = (function(){

          function init(spinner) {
              switch (spinner.spinner) {
                  case 'theCircle':
                      theCircle.init(spinner);
                      break;
                  case 'theTail':
                      theTail.init(spinner);
                      break;
                  case 'star':
                      theExperiments.init(spinner);
                      break;
                  case 'wormII':
                      theMultiLayer.init(spinner);
                      break;
                  case 'worm':
                      theWorm.init(spinner);
                      break;
                  case 'drop':
                      theGravity.init(spinner);
                      break;
                  case 'theWeirdSpoke':
                      theWeirdSpoke.init(spinner);
                      break;
                  case 'theWatch':
                      theWatch.init(spinner);
                      break;
                  case 'catchUpSpinnerII' :
                      theCatchupExperiment.init(spinner);
                      break;
                  case 'theGear' :
                      theGear.init(spinner);
                      break;
              }
          }
          
      
          function particleFactory (amount, width, height, arcRadius, customAngle, ifSprings, friction, springStrength, springLength) {
              var angle =  customAngle ? customAngle : 0;
              var particles = [];
              for (var i = 0; i < amount; i++) {
                  var myParticle = particle.create(width / 2 + Math.cos(angle) * arcRadius, height / 2 + Math.sin(angle) * arcRadius, 0, 0, 0);
                  var springPoint = particle.create(width / 2, height / 2 , 0, 0, 0);
                  if (ifSprings) {
                      myParticle.friction =  friction;
                      myParticle.addSpring(springPoint, springStrength, springLength);
                  }
                  myParticle.angleStart = angle;
                  angle += Math.PI / (amount / 2);
                  myParticle.angleStop = angle;
                  myParticle.arcX = myParticle.x;
                  myParticle.arcY = myParticle.y;
                  particles.push(myParticle);
              }
              return particles;
          }
      
          return {
              init : init,
              particleFactory : particleFactory
          }
      
      })();
      

      (function(){

        new ClockSpinner(config, spinners)
        
      })();
        
        function ClockSpinner (spinner){
          var canvas = null,
              context = null,
              width = null,
              height = null;
      
          var arcRadius = null,
              speedMinutes = null,
              speedHour = null,
              startAngleMinutes = null,
              startAngleHours = null,
              armWidthMinute = null,
              armWidthHour = null,
              clockLineWidth = null,
              armColorMinute = null,
              armColorHour = null,
              clockColorLine = null,
              clockColorFill = null,
              indicatorColorFill = null,
              color = null,
              direction = null,
              opacity = null;
      
          var ratio = null;
      
          var particles = [];
      
          init(spinner);
      
          function init (spinner) {
              if (setEnviroment(spinner) === 2) {
                spinner.options.radius = spinner.options.radius * 2;
                spinner.advancedOptions.armWidthMinute = spinner.advancedOptions.armWidthMinute * 2;
                spinner.advancedOptions.armWidthHour = spinner.advancedOptions.armWidthHour * 2;
                spinner.advancedOptions.clockLineWidth = spinner.advancedOptions.clockLineWidth * 2;
              };
              standardOptions(spinner);
              specificOptions(spinner);
              clearCanvas();
          }
      
          function setEnviroment (spinner) {
              var container = document.getElementById(spinner.setup.containerId);
              canvas = document.getElementById(spinner.setup.canvasId);
              context = canvas.getContext('2d');
              return retinaDimensions(container);
          }
      
          function retinaDimensions (container) {
            var devicePixelRatio = window.devicePixelRatio || 1; 
            var backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
            ratio = devicePixelRatio / backingStoreRatio;
            width = canvas.width = container.offsetWidth * ratio;
            height = canvas.height = container.offsetHeight * ratio;
            canvas.style.width = width / ratio + 'px';
            canvas.style.height = height / ratio + 'px';
            return devicePixelRatio;
          }
      
          function standardOptions (spinner) {
              arcRadius = spinner.options.radius ? spinner.options.radius : 15;
              speedMinutes = spinner.options.speed ? spinner.options.speed : 0.1;
              speedHour = speedMinutes / 12;
              direction = spinner.options.direction ? spinner.options.direction : 'right';
              opacity = spinner.options.opacity ? spinner.options.opacity : 1;
          }
      
          function specificOptions (spinner) {
              startAngleMinutes = spinner.advancedOptions.startAngleMinutes ? spinner.advancedOptions.startAngleMinutes : 0;
              startAngleHours = spinner.advancedOptions.startAngleHours ? spinner.advancedOptions.startAngleHours : 0;
              armWidthMinute = spinner.advancedOptions.armWidthMinute ? spinner.advancedOptions.armWidthMinute : 1;
              armWidthHour = spinner.advancedOptions.armWidthHour ? spinner.advancedOptions.armWidthHour : 2;
              clockLineWidth = spinner.advancedOptions.clockLineWidth ? spinner.advancedOptions.clockLineWidth : 1;
              armColorMinute = spinner.advancedOptions.armColorMinute ? spinner.advancedOptions.armColorMinute : '#4b4b4b';
              armColorHour = spinner.advancedOptions.armColorHour ? spinner.advancedOptions.armColorHour : '#4b4b4b';
              clockColorLine = spinner.advancedOptions.clockColorLine ? spinner.advancedOptions.clockColorLine : '#4b4b4b';
              clockColorFill = spinner.advancedOptions.clockColorFill ? spinner.advancedOptions.clockColorFill : '#ffffff';
              indicatorColorFill = spinner.advancedOptions.indicatorColorFill ? spinner.advancedOptions.indicatorColorFill : '#4b4b4b';
      
              if (spinner.advancedOptions.hoursIndicator) {
                  particles = spinners.particleFactory(12, width, height, arcRadius / 1.2, 0, false, null, null, null);
              }
          }
      
          function clearCanvas() {
              context.clearRect(0, 0, width, height);
              render();
              requestAnimationFrame(clearCanvas);
          }
      
          function render () {
              context.save();
      
              context.globalAlpha = opacity;
      
              context.beginPath();
              context.arc(width / 2, height / 2, arcRadius, 0, Math.PI * 2, false);
              context.strokeStyle = clockColorLine;
              context.lineWidth = clockLineWidth;
              context.fillStyle = clockColorFill;
              context.globalAlpha = opacity;
              context.fill();
              context.stroke();
      
              for (var i = 0; i < particles.length; i++) {
                  context.beginPath();
                  context.arc(particles[i].x, particles[i].y, 1, 0, Math.PI * 2, false);
                  context.fillStyle = indicatorColorFill;
                  context.fill();
              }
      
              context.beginPath();
              context.moveTo(width / 2, height / 2);
              context.lineTo(width / 2 + Math.cos(startAngleHours) * (arcRadius / 2), height / 2 + Math.sin(startAngleHours) * (arcRadius / 2));
              context.strokeStyle = armColorHour;
              context.lineWidth = armWidthHour;
              context.stroke();
      
              context.beginPath();
              context.moveTo(width / 2, height / 2);
              context.lineTo(width / 2 + Math.cos(startAngleHours) * -(arcRadius / 4), height / 2 + Math.sin(startAngleHours) * -(arcRadius / 4));
              context.strokeStyle = armColorHour;
              context.lineWidth = armWidthHour;
              context.stroke();
      
              context.beginPath();
              context.moveTo(width / 2, height / 2);
              context.lineTo(width / 2 + Math.cos(startAngleMinutes) * (arcRadius / 1.3), height / 2 + Math.sin(startAngleMinutes) * (arcRadius / 1.3));
              context.strokeStyle = armColorMinute;
              context.lineWidth = armWidthMinute;
              context.stroke();
      
              context.beginPath();
              context.moveTo(width / 2, height / 2);
              context.lineTo(width / 2 + Math.cos(startAngleMinutes) * -(arcRadius / 3) , height / 2 + Math.sin(startAngleMinutes) * -(arcRadius / 3));
              context.strokeStyle = armColorMinute;
              context.lineWidth = armWidthMinute;
              context.stroke();
      
      
              if (direction === 'right') {
                  startAngleMinutes += speedMinutes;
                  startAngleHours += speedHour;
              } else if (direction === 'left') {
                  startAngleMinutes -= speedMinutes;
                  startAngleHours -= speedHour;
              }
      
              context.restore();
          }
      
          return {
              init : init
          }
      };

     
        

      }
    };
  }

  pxSpinner.$inject = ['$timeout', '$filter', '$window'];

  angular
    .module('printix-admin')
    .directive('pxSpinner', pxSpinner);

})();
